export default __webpack_public_path__ + "static/industryIntegration-ea142e408437df5175d4a106df7fa60c.png";